import { LoginComponentProps, LoginComponentHandler } from './logincomponent';
import { LoginCSSStyle } from './logincss';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
//import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { CheckboxComponent } from '../../../toolkit/checkbox/checkboxcomponent';
import { CheckboxCSSStyleImpl } from '../../../toolkit/checkbox/checkboxcss';
//import { LoginDto, LoginDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/login/logindto';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { Strings } from '../../../../utils/resources/strings';
import { LoginDto, LoginDtoImpl } from '../../../../core/dto/login/logindto';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';

import './login-style.css';
import { PasswordTextComponent } from '../../../toolkit/floatingtext/password/passwordtextcomponent';

export class LoginViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private popupComponent:PopUpWrapperComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private numberComponent: any;
    private passwordComponent: any;

    private rememberCheckBox: CheckboxComponent | null;
    

    bindHandlers()
    {
        this.onLoginButtonClick = this.onLoginButtonClick.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
        this.onForgotPasswordClick = this.onForgotPasswordClick.bind(this);
        this.onSignUpClick = this.onSignUpClick.bind(this);
        this.onKeyPressEvent = this.onKeyPressEvent.bind(this);
        
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.validateLoginDetails = this.validateLoginDetails.bind(this);
        // document.addEventListener("keydown",this.onKeyPressEvent);

    }

    draw(props: LoginComponentProps, state: UIComponentState, cssStyle: LoginCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
     

        return (
            
            <div id="login-wrapper" style={cssStyle.getWrapperCSSStyle()}>
           
                <div id="login-inner-wrapper"  style={cssStyle.getInnerWrapperCSSStyle()}>
         
                    <img id="login-page-logo" onClick={this.onLogoClicked} style={{cursor: "pointer", marginBottom:'45px',marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
           
                    <label id="login-page-heading" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.logintouraccount)}</label>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                         
                        <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.numberComponent = item} id={"#mobileNumber"} value={props.context.getUserContext().getMsisdn()} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.mobilenumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
                    </div>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                        <PasswordTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.passwordMaxLength)} ref={(item: any) => this.passwordComponent = item} id={"#password"} value={props.context.getUserContext().getIsRememberMe() ? props.context.getUserContext().getPassword(): ""} inputType={"password"} isRequired={true} placeholder={props.context.getResources().getString(Strings.password)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.passwordIncorrect)}/>
                    </div>
                    <div style={cssStyle.getRowDivCSSStyle()}>
                        <CheckboxComponent  isEditable={true}  ref={(item: any) => this.rememberCheckBox = item} style={new CheckboxCSSStyleImpl(props.context)} onChange={() => {}} context={props.context} isChecked={props.context.getUserContext().getIsRememberMe()}/>
                        <label id="login-remember-me-label" style={cssStyle.getRememberMeCSSStyle()}>{props.context.getResources().getString(Strings.rememberme)}</label>
                        <label id="login-page-forgot-password" onClick={this.onForgotPasswordClick} style={cssStyle.getForgotPasswordCSSStyle()}>{props.context.getResources().getString(Strings.forgotpassword)}</label>
                    </div>
                    <div  style={cssStyle.getLoginButtonCSSStyle()}>
                        <ButtonComponent   onClick={this.validateLoginDetails}  style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.login)}/>
                    </div>
                    <br/>
                    <div style={cssStyle.getSignUpRowDivCSSStyle()}>
                        <label style={cssStyle.getDoUHaveAccountCSSStyle()}>{props.context.getResources().getString(Strings.dontvetheaccount)}</label>
                        <label id="login-page-signup" onClick={this.onSignUpClick} style={cssStyle.getSignUpCSSStyle()}>{props.context.getResources().getString(Strings.signup)}</label>
                    </div>
                </div>
                
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
              
                <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>

            </div>
        );
    }
    protected onLogoClicked()
    {
        (this.getUIComponentHandler() as LoginComponentHandler).onLogoClicked();
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    }
    hidePopup()
    { 
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }
    onKeyPressEvent(event:any):void
    {
        console.log("key code", event.code+event.keyCode);
          if(event.code === "Enter")
          {
              this.validateLoginDetails();
          }
    }
    getUIComponentHandler(): LoginComponentHandler
    {
        return super.getUIComponentHandler() as LoginComponentHandler;
    }

    validateLoginDetails(): void
    {
        if(this.numberComponent.validate() && this.passwordComponent.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.numberComponent.getData());

            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

            let passwordMinLength = +this.getUIProps().context.getResources().getString(Strings.passwordMinLength);
            let passwordmaxLength = +this.getUIProps().context.getResources().getString(Strings.passwordMaxLength);

            console.log("msidoing: " + msisdn);
            console.log("numbermaxLength: " + numbermaxLength);
            console.log("numbermaxLnumberMinLengthength: " + numberMinLength);

            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
            }
            
            else if(this.passwordComponent.getData().length < passwordMinLength 
                        || this.passwordComponent.getData().length > passwordmaxLength)
            {
                this.passwordComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
            }
            else
            {
                this.passwordComponent.setErrorMessage(undefined);
                this.numberComponent.setErrorMessage(undefined);

                this.onLoginButtonClick();
            }
        }     
       
    }

    getData(): LoginDto
    {
        let request = new LoginDtoImpl();
        request.setMsisdn(this.numberComponent.getData());
        request.setPassword(this.passwordComponent.getData());

        return request;
    }

    isRememberMe(): boolean
    {
        return this.rememberCheckBox !== null ? this.rememberCheckBox.isChecked() : false;
    }

    private onLoginButtonClick()
    {
        (this.getUIComponentHandler() as LoginComponentHandler).onLoginButtonClick();
    }

    private onSignUpClick()
    {
        (this.getUIComponentHandler() as LoginComponentHandler).onSignUpClick();
    }

    private onForgotPasswordClick()
    {
        (this.getUIComponentHandler() as LoginComponentHandler).onForgotpassword();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/login/loginview.tsx